const stageBackendSettings: any = {
  local: {
    api: {
      // yarn localで実行したときはserverless-offlineによるローカルサービスを参照
      baseURL: 'http://localhost:4010',
    },
    auth: {
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_Wuf3jmip3',
      userPoolWebClientId: '6uivgkr6q8vglja87of95k1811',
    },
  },
  dev: {
    api: {
      baseURL: 'https://eqiymo3s9c.execute-api.ap-northeast-1.amazonaws.com/dev',
    },
    auth: {
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_Wuf3jmip3',
      userPoolWebClientId: '6uivgkr6q8vglja87of95k1811',
    },
  },
  stg: {
    api: {
      baseURL: '', // 同一ドメイン
    },
    auth: {
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_vJ5k5OXrk',
      userPoolWebClientId: '7gp5q4k92n898b5q3uoi8g9ul',
    },
  },
  prod: {
    api: {
      baseURL: '', // 同一ドメイン
    },
    auth: {
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_0nSR53c76',
      userPoolWebClientId: '1a0htqqa8ksk7hsvhskpf0fqu3',
    },
  },
};


export const apiRoot = stageBackendSettings[process.env['REACT_APP_STAGE'] ?? 'dev'].api.baseURL;
export const cognitoAuthConfig = stageBackendSettings[process.env['REACT_APP_STAGE'] ?? 'dev'].auth;

export const COPYRIGHT = '© 2022 Insight Edge, Inc.';